import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../models/Login";
import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Search } from "../../shared/Search";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IEmptyFilter } from "./Filter";
import { Fetch } from "../../shared/Fetch";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    toast: any,
    permissions: IPermissionProps
}

interface IUserLoginHistory {
    user_Name?: string,
    branchName?: string,
    company_Name?: string,
    login_IP?: string,
    login_Time?: Date,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IUserLoginHistory>, loading: boolean });
    const [filters, setFilters] = useState<IEmptyFilter>(EmptyFilter);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"> Major Technology</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                {/* <Search setSearch={setGlobalFilter} /> */}
            </span>
        </div>
    );

    const loaddata = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        // `filter=${JSON.stringify(filter)}`
        const response = await Fetch("tbl_User_Login_History", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data: IUserLoginHistory[] = await response?.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    useEffect(() => {
        loaddata();
    }, [filters]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter setFilters={(filters: IEmptyFilter) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            {props.permissions.is_View && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                size="small"
                scrollable showGridlines
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: "4rem" }} />
                <Column field="user_Name" header="User" />
                <Column field="branchName" header="Branch" style={{ maxWidth: "12rem" }} />
                <Column field="company_Name" header="Company" />
                <Column field="login_IP" header="IP" />
                {/* <Column field="login_Time" header="Login Time" style={{maxWidth: "15rem"}} /> */}
                <Column field="login_Time" header="Login Time" style={{ maxWidth: "15rem" }} body={(rowData: any) => safeFormatDate(rowData.login_Time, 'dd/MM/yyyy HH.mm.ss', DateFormat, true, true)} />
            </DataTable>}
        </>
    );
}